<template>
    <div>
        <b-modal v-for="item in items" :id="'bv-modal-password'+item.key" :key="item.key" :visible="item.show"
                 centered @hide="onClose(item)"
        >
            <template v-slot:modal-title>
                {{ trans('recaptcha-modal-page.Modal title') }}
            </template>
            <div class="modal-body">
                <vue-recaptcha
                    :loadRecaptchaScript="loadRecaptcha"
                    :recaptchaType="recaptchaType"
                    @verify="onVerify($event, item)"
                    @expired="onExpired(item)"
                    :sitekey="sitekey">
                </vue-recaptcha>

                <a href="/support-tinywow" target="_blank">{{ trans('recaptcha-modal-page.Tired link') }}</a>
            </div>
            <template v-slot:modal-footer>
                <button type="button" class="btn btn-secondary" @click="onClose(item)">
                    {{ trans('recaptcha-modal-page.Cancel btn') }}
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import VueRecaptcha from '../vue-recaptcha/vue-recaptcha';

const key = () => `${Date.now()}-${Math.random()}`;

export default {
    data      : function () {
        return {
            items        : [],
            sitekey      : window.Laravel.captcha_sitekey,
            loadRecaptcha: window.Laravel.loadProd
        };
    },
    components: {
        'vue-recaptcha': VueRecaptcha,
    },
    computed  : {
        recaptchaType() {
            return window.Laravel.cT;
        }
    },
    methods   : {
        open() {
            if (!this.$parent) {
                this.$mount();
                document.body.appendChild(this.$el)
            }
            return new Promise(resolve => {
                const item = {
                    key : key(),
                    show: true,
                    resolve
                };
                this.items.push(item)
            })
        },
        onVerify : function (token, item) {
            const response = {
                status: 'verify',
                token : token,
            };

            item.resolve(response);
            item.show = false;
            this.remove(item)
        },
        onExpired: function (item) {
            const response = {
                status: 'expired',
            };

            item.resolve(response);
            item.show = false;
            this.remove(item)
        },
        onClose  : function (item) {
            const response = {
                status: 'closed',
            };

            item.resolve(response);
            item.show = false;
            this.remove(item)
        },
        remove(item) {
            let i = this.items.indexOf(item);
            if (i >= 0) {
                this.items.splice(i, 1)
            }
        },
    }
}
</script>
